var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationRegistry2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.75 39.375H11.25C8.15625 39.375 5.625 36.8437 5.625 33.75V11.25C5.625 8.15625 8.15625 5.625 11.25 5.625H33.75C36.8437 5.625 39.375 8.15625 39.375 11.25V33.75C39.375 36.8437 36.8437 39.375 33.75 39.375Z",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5018 21.1088C22.5018 16.6988 25.5637 13.125 29.3399 13.125C30.9655 13.125 32.2837 14.4431 32.2837 16.0687C32.2837 19.62 27.9018 22.5 22.498 22.5C17.0943 22.5 12.7124 19.6219 12.7124 16.0687C12.7124 14.4431 14.0305 13.125 15.658 13.125C19.4343 13.125 22.4962 16.6988 22.4962 21.1088",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15 29.7264C19.14 29.7264 22.4963 25.8076 22.4963 20.9739L22.5037 21.0001C22.5037 25.8339 25.86 29.7526 30 29.7526",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 5.625V39.375",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 22.5H5.625",
    stroke: "currentColor",
    strokeWidth: "inherit",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationRegistry2);
export default __webpack_public_path__ + "static/media/navigation-registry2.0789df60.svg";
export { ForwardRef as ReactComponent };